import Typography from '@portalterreno/react-ui-core/Typography';
import React from 'react';

import Description from './Description';
import Wrapper from './Wrapper';

const DirectCredit: React.FC = () => {
  return (
    <Wrapper>
      <Typography
        variant='text'
        as='p'
        weight='regular'
      >
        Financiamiento
      </Typography>
      <Typography
        variant='body2'
        weight='semibold'
        color='midnightBlue'
      >
        Crédito Directo
      </Typography>
      <Description />
    </Wrapper>
  );
};

export default React.memo(DirectCredit);
